import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
//import authentication from 'react-azure-b2c';
import { BrowserRouter } from 'react-router-dom';
//import 'bootstrap/dist/css/bootstrap.css';
import './site.min.css'
import App from './App';
//import * as serviceWorker from './serviceWorker';
import registerServiceWorker from './registerServiceWorker';
//import { initializeUser } from './API';

import * as b2c from './b2c/b2c';
import { MsalProvider } from "@azure/msal-react";
import * as msal from "@azure/msal-browser";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

(async () => {
    // Default options are marked with *
    const response = await fetch('/appsettings.json', {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'same-origin', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'same-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    });
    window.env = await response.json(); // parses JSON response into native JavaScript objects

    const config = {
        instance: window.env.b2c.instance, //'https://stateofsouthdakotapublic.b2clogin.com/stateofsouthdakotapublic.onmicrosoft.com/B2C_1_SignUp_SignIn_WithAad/v2.0/.well-known/openid-configuration',
        tenant: window.env.b2c.tenant, //'stateofsouthdakotapublic.onmicrosoft.com',
        signInPolicy: window.env.b2c.signInPolicy, //'B2C_1_SignUp_SignIn_WithAad',
        domain: window.env.b2c.domain,
        resetPasswordPolicy: window.env.b2c.resetPasswordPolicy,
        clientId: window.env.b2c.clientId, //'8515e466-1d9d-4269-b0e0-a2029063ed28',
        cacheLocation: window.env.b2c.cacheLocation, //'sessionStorage',
        scopes: window.env.b2c.scopes, //['https://stateofsouthdakotapublic.onmicrosoft.com/nr06environmentalfeesapi/read', 'https://stateofsouthdakotapublic.onmicrosoft.com/nr06environmentalfeesapi/write'],
        redirectUri: window.env.b2c.redirectUri, //'http://localhost:3000', 'https://app-danr-dev-nr06environmentalfees.azurewebsites.net/'
        postLogoutRedirectUri: window.location.href
    };
    const msalConfig = b2c.generateMsalConfig(config);
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
       
    }

    //msalInstance.addEventCallback((event) => {
    //    if ((event.eventType === msal.EventType.LOGIN_SUCCESS || event.eventType === msal.EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === msal.EventType.SSO_SILENT_SUCCESS) && event.payload.account) {
    //        const account = event.payload.account;
    //        msalInstance.setActiveAccount(account);
    //    }
    //});

    ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
            <MsalProvider instance={msalInstance}>
                <App pca={msalInstance} />
            </MsalProvider>
        </BrowserRouter>,
        rootElement);

    registerServiceWorker();
})();